'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/lib/utils';

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
    return <TabsPrimitive.Root data-slot="tabs" className={cn('flex flex-col  gap-2', className)} {...props} />;
}

function TabsList({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                `
        grid grid-cols-2 gap-1 p-1 rounded-lg
        bg-muted text-muted-foreground

        sm:grid-cols-3
        lg:flex lg:h-9 lg:w-fit lg:items-center lg:justify-center lg:p-[3px]
        `,
                className
            )}
            {...props}
        />
    );
}


function TabsTrigger({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(
                `
        flex items-center justify-center gap-2
        rounded-md px-3 py-2 text-sm font-bold
        whitespace-nowrap transition-all

        text-brand-black
        data-[state=active]:bg-brand-white
        data-[state=active]:text-brand-blue
        data-[state=active]:shadow-lg

        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        disabled:pointer-events-none disabled:opacity-50
        `,
                className
            )}
            {...props}
        />
    );
}


function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
    return (
        <TabsPrimitive.Content data-slot="tabs-content" className={cn('flex-1 outline-none', className)} {...props} />
    );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
